import { render, staticRenderFns } from "./InsertProject.vue?vue&type=template&id=3cf70e98&scoped=true"
import script from "./InsertProject.vue?vue&type=script&lang=js"
export * from "./InsertProject.vue?vue&type=script&lang=js"
import style0 from "./InsertProject.vue?vue&type=style&index=0&id=3cf70e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf70e98",
  null
  
)

export default component.exports